import React, { Fragment, useEffect, useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

const Branch = (props) => {
  const [grid, setGrid] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const editRecord = (val) => {
    var temp = window.btoa(val);
    console.log(temp);
    props.history.push("/company/branch/add?id=" + temp);
  };

  const [gridParam, setGridParam] = useState({});
  const columns = [
    {
      key: "branch_code",
      text: "Branch Code",
      align: "left",
      sortable: true,
    },
    {
      key: "company_name",
      text: "Company Name",
      align: "left",
      sortable: true,
    },
    {
      key: "brand_name",
      text: "Brand Name",
      sortable: true,
      align: "left",
    },
    {
      key: "address",
      text: "Address",
      sortable: true,
      align: "left",
    },
    {
      key: "city",
      text: "City",
      sortable: true,
      align: "left",
    },
    {
      key: "state",
      text: "State",
      sortable: true,
      align: "left",
    },
    {
      key: "country",
      text: "Country",
      sortable: true,
      align: "left",
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-link btn-sm"
              onClick={() => editRecord(record.branch_id)}
              style={{ marginRight: "5px" }}
              title="Edit Branch"
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              className="btn btn-link btn-sm text-success"
              onClick={() => {
                var temp = window.btoa(record.branch_id);
                props.history.push("/company/branch/whatsapptemplate?id=" + temp);
              }}
              style={{ marginRight: "5px" }}
              title="WhatsApp Templates"
            >
              <i className="fa fa-whatsapp font-size-h5"></i>
              
            </button>
          </Fragment>
        );
      },
    },
  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
  };

  useEffect(() => {
    setLoad(true);
    postMethod("api/masters/branch/browse", gridParam).then((data) => {
      setGrid(data.data);
      setLoad(false);
    });
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <div className="card card-custom gutter-b">
        <div className="card-header">
          <div className="card-title">
            <h3 className="card-label">Branch</h3>
          </div>
          <div className="card-toolbar">
            <a
              href="/company/branch/add"
              className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3"
            >
              <i className="flaticon2-user"></i> Add Branch
            </a>
          </div>
        </div>
        <div className="card-body">
          <ReactDatatable config={config} records={grid} columns={columns} />
        </div>
      </div>
    </>
  );
};

export default Branch;
